class MyFavorite {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("myFavorite", () => ({
                    noFetchSearches: null,
                    agendaTypes: [],
                    agendaTags: [],
                    listResult: {},

                    day: null,
                    totalSave: 0,
                    maxSave: 5,

                    LOADING: 1,
                    ERROR: 2,

                    searches: [],
                    stateMySearch: false,
                    stateSaveSearch: false,

                    getSavedSearch: null,

                    daysLabel: [
                        "dimanches",
                        "lundis",
                        "mardis",
                        "mercredis",
                        "jeudis",
                        "vendredis",
                        "samedis",
                    ],

                    init() {
                        window.alpineRender(this);

                        if (window.CONFIG.connected && !this.noFetchSearches) {
                            this.searchesList();
                        }
                    },
                    searchesList() {
                        this.stateMySearch = this.LOADING;
                        window.useHttpApi
                            .get("/v1/searches")
                            .then(({ body }) => {
                                this.day = body.day;
                                this.totalSave = body.total;
                                this.maxSave = body.max;

                                body.searches.forEach((search) => {
                                    if (
                                        search.agenda ===
                                        window.CONFIG.agenda.id
                                    ) {
                                        this.searches.push(search);
                                        if (
                                            this.listResult.hash === search.hash
                                        ) {
                                            this.getSavedSearch = search;
                                        }
                                    }
                                });
                                this.stateMySearch = null;
                            })
                            .catch(() => {
                                this.stateMySearch = this.ERROR;
                            });
                    },

                    getLabelFromTagsList(tags) {
                        if (!tags.length) {
                            return "Tous les Types";
                        }
                        const types = this.agendaTypes;
                        const filteredTypes = [];
                        types.forEach((type) => {
                            const filteredChildren = type.tags.filter((tag) =>
                                tags.includes(tag.id),
                            );

                            if (filteredChildren.length > 0) {
                                const newType = {
                                    ...type,
                                    tags: filteredChildren,
                                };
                                filteredTypes.push(newType);
                            }
                        });

                        let label = null;
                        let nbrCheckedTags = 0;

                        if (filteredTypes.length === 1) {
                            const type = filteredTypes[0];
                            const checkedTags = type.tags;

                            if (checkedTags.length === 1) {
                                label = checkedTags[0].labelSingular;
                            } else if (
                                checkedTags.length === type.tags.length
                            ) {
                                label = type.labelSingular;
                            } else {
                                label = `${checkedTags.length} types d'évènements`;
                            }
                        } else if (tags.length === this.agendaTags.length) {
                            label = "Tous les Types";
                        } else {
                            filteredTypes.forEach((type) => {
                                nbrCheckedTags += type.tags.length;
                            });
                            label = `${nbrCheckedTags} types d'évènements`;
                        }

                        return label;
                    },
                }));
            },
            { once: true },
        );
    }
}

new MyFavorite();
